import React from 'react';
import './index.scss';

const FirstPageSkeleton = () => {
  return (
    <div className="skeleton-container">
      <div className="announcements-container-block"></div>
      <div className="hot-question-category-block">
        <div className="category-item-block"></div>
        <div className="category-item-block"></div>
        <div className="category-item-block"></div>
        <div className="category-item-block"></div>
      </div>
    </div>
  );
};

export default FirstPageSkeleton;
